/**
 * One number from a finished session — ROUTE_INVENTORY §2.11 #72 and #77.
 *
 * Shared by the just-finished results screen and the past-session detail
 * view, where it was byte-identical in both. They are the same claim about the
 * same three grades; the only difference was which object the numbers came
 * from (live outcomes vs a persisted record), and that belongs to the caller.
 *
 * The tone dot carries the grade's colour without the NUMBER being coloured —
 * a 3xl figure in rose reads as an error rather than as a count.
 */
export function SessionStatCard({
  label,
  value,
  tone,
}: {
  label: string;
  value: number;
  tone: 'emerald' | 'indigo' | 'rose';
}) {
  const dotCls = {
    emerald: 'bg-emerald-500',
    indigo: 'bg-brand-500 dark:bg-primary',
    rose: 'bg-rose-500',
  }[tone];
  return (
    <div className='flex flex-col items-center justify-center rounded-2xl border border-border bg-card p-5'>
      <span className='text-3xl font-semibold tabular-nums text-foreground'>
        {value}
      </span>
      <span className='mt-2 inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-muted-foreground'>
        <span className={`h-1.5 w-1.5 rounded-full ${dotCls}`} />
        {label}
      </span>
    </div>
  );
}
